import React, { useEffect, useState } from 'react'
import LocalStorage from 'src/utils/LocalStorage'

interface propTypes {
  className?: string
  menuNameProp?: string
}

const MenuNameComponent = (props: propTypes) => {
  const { className, menuNameProp } = props
  const [menuName, setMenuName] = useState<string | null>(
    menuNameProp || LocalStorage.getMenuName(),
  )

  useEffect(() => {
    // Cập nhật khi mount hoặc khi prop thay đổi
    setMenuName(menuNameProp || LocalStorage.getMenuName())

    // Lắng nghe sự kiện custom khi menu name thay đổi trong cùng tab
    const handleMenuNameChange = (e: any) => {
      setMenuName(menuNameProp || e.detail || LocalStorage.getMenuName())
    }

    window.addEventListener('menuNameChanged', handleMenuNameChange)
    return () => {
      window.removeEventListener('menuNameChanged', handleMenuNameChange)
    }
  }, [menuNameProp])

  return (
    <>
      {menuName && (
        <div className={`fs-15 fw-400 ${className}`}>診療科目：{menuName}</div>
      )}
    </>
  )
}

export default MenuNameComponent
